<template>
  <div class="toggle-box">
    <toggle-button
      v-if="!hasControl"
      :blue="blue"
      :white="white"
      :text="text"
      :disabled="disabled"
      @click="toggle"
      :pure-icon="pureIcon"
      :rounded-corner="roundedCorner"
    >
      <template v-slot:icon>
        <slot name="icon" />
      </template >
    </toggle-button>
    <slot v-if="hasControl" name="control" />
    <transition name="fade">
      <div v-show="active" class="toggle-box-wrapper" ref="wrapper" :class="{ 'has-border': hasBorder, 'hide-indicator': hideIndicator }">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, watch, onUnmounted, computed } from '@vue/composition-api';
import $ from 'jquery';

import ToggleButton from '@/components/ToggleButton';

export default {
  name: 'ToggleBox',
  components: {
    ToggleButton
  },
  props: {
    text: String,
    blue: Boolean,
    white: Boolean,
    disabled: Boolean,
    hasBorder: Boolean,
    hideIndicator: Boolean,
    pureIcon: Boolean,
    roundedCorner: Boolean
  },
  setup(props, { refs, emit, slots }) {
    const active = ref(false);

    const hasControl = computed(() => !!slots.control);

    const toggle = (val) => {
      if ((val === false) || (val === true)) {
        active.value = val;
      } else {
        active.value = !active.value;
      }

      if (active.value) {
        emit('show');
      } else {
        emit('hide');
      }
    };

    const watchWrapper = (e) => {
      const elem = refs.wrapper;
      if (!elem) return;

      let { pageX, pageY } = e;
      let { top, left } = $(elem).offset();
      let width = $(elem).width();
      let height = $(elem).height();

      if ((pageX < left) || (pageX > left + width) || (pageY < top) || (pageY > top + height)) {
        ({ pageX, pageY } = e);
        ({ top, left } = $(elem).offset());
        width = $(elem).outerWidth();
        height = $(elem).outerHeight();

        if ((pageX < left) || (pageX > left + width) || (pageY < top) || (pageY > top + height)) {
          toggle(false);
          emit('close');
        }
      }
    };

    watch(active, (next) => {
      if (next) {
        setTimeout(() => {
          $(document.body).on('click', watchWrapper);
        }, 500);
      } else {
        $(document.body).off('click', watchWrapper);
      }
    });

    onUnmounted(() => {
      $(document.body).off('click', watchWrapper);
    });

    return {
      active,
      toggle,
      hasControl
    };
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors';

.toggle-box {
  position: relative;

  .text-input {
    width: 100%;
  }

  .toggle-box-wrapper {
    position: absolute;
    top: calc(100% + 14px);
    right: 0;
    box-shadow: 0px 3px 6px #00000029;
    background-color: $white;
    padding: 15px;
    z-index: 999;
    box-sizing: border-box;
    border-radius: 3px;

    &::before {
      content: "";
      position: absolute;
      top: -9px;
      right: 30px;
      transform: rotate(45deg);
      width: 18px;
      height: 18px;
      background: linear-gradient(-45deg, rgba(255, 255, 255, 0) 50%, $white 50%);
    }

    &.has-border {
      border: 1px solid $alto;

      &::before {
        border-top: 1px solid $alto;
        border-left: 1px solid $alto;
      }
    }

    &.hide-indicator {
      &::before {
        display: none;
      }
    }

    &.fade-enter-active, &.fade-leave-active {
      transition: opacity .2s ease-in-out;
    }

    &.fade-enter, &.fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
